<template>
  <div class="container ">
    <h1 class="text-center my-3" v-t="`search.single.title`"></h1>
    <search-input/>

    <section v-for="(section,sectionName) in result">
      <SearchSections v-if="section.data.length"
                      :section="section"
                      :offerType="offerType"
                      :productCardName="productCardName"
                      :offerStatus="offerStatus"
                      :section-name="sectionName"/>

      <div class="text-center" v-else>
        <h1>{{ $t(`search.single.${sectionName}`) }}</h1>
        <p v-t="`search.single.no_item`"></p>
      </div>

    </section>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {searchTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Search'
import SearchInput from "./Search/SearchInputArchive";
import SearchSections from "./Search/SearchSections";
import {OfferProps} from '../../../Product/ProductOffer/ProductOfferProps'
import {Cards} from "../../../Product/Card/Cards";

export default {
  name: "Search",
  components: {SearchInput, SearchSections},
  props: {
    ...OfferProps,
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    }
  },
  data() {
    return {
      searchParams: {
        words: '',
        type: '',
      },
      searchTypes,
    }
  },
  computed: {
    ...mapGetters({
      result: 'Search/getResult'
    })
  },
  methods: {
    setSearchParameters() {
      this.searchParams.words = this.$route.params.words
      this.searchParams.type = this.$route.params.type
    },
  },
  mounted() {
    this.setSearchParameters();

    if (process.env.NODE_ENV == 'development') { // use for test in local
      this.searchParams.words = 'خانه'
      this.searchParams.type = 'product'
    }

    this.$store.dispatch('Search/search', {type: this.searchParams.type, words: this.searchParams.words})
  },
  watch: {
    $route(to, from) {
      if (this.$route.name === 'Search') {
        this.setSearchParameters();
        this.$store.dispatch('Search/search', {type: this.searchParams.type, words: this.searchParams.words})
      }
    }
  }
}
</script>

<style scoped>

</style>